import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Polski",
  code: "pl",
  messages: {
    alert: {
      close: "Zamknij"
    },
    authForm: {
      hidePassword: "Ukryj has\u0142o",
      showPassword: "Poka\u017C has\u0142o",
      submit: "Kontynuuj"
    },
    banner: {
      close: "Zamknij"
    },
    calendar: {
      nextMonth: "Przysz\u0142y miesi\u0105c",
      nextYear: "Przysz\u0142y rok",
      prevMonth: "Poprzedni miesi\u0105c",
      prevYear: "Poprzedni rok"
    },
    carousel: {
      dots: "Wybierz slajd do wy\u015Bwietlenia",
      goto: "Id\u017A do {slide}",
      next: "Nast\u0119pny",
      prev: "Poprzedni"
    },
    chatPrompt: {
      placeholder: "Tutaj wpisz swoj\u0105 wiadomo\u015B\u0107..."
    },
    chatPromptSubmit: {
      label: "Wy\u015Blij"
    },
    colorMode: {
      dark: "Ciemny",
      light: "Jasny",
      switchToDark: "Prze\u0142\u0105cz na tryb ciemny",
      switchToLight: "Prze\u0142\u0105cz na tryb jasny",
      system: "System"
    },
    commandPalette: {
      back: "Wstecz",
      close: "Zamknij",
      noData: "Brak danych",
      noMatch: "Brak pasuj\u0105cych danych",
      placeholder: "Wpisz polecenie lub wyszukaj..."
    },
    contentSearch: {
      links: "Linki",
      theme: "Motyw"
    },
    contentSearchButton: {
      label: "Szukaj..."
    },
    contentToc: {
      title: "Na tej stronie"
    },
    dashboardSearch: {
      theme: "Motyw"
    },
    dashboardSearchButton: {
      label: "Szukaj..."
    },
    dashboardSidebarCollapse: {
      collapse: "Zwi\u0144 pasek boczny",
      expand: "Rozwi\u0144 pasek boczny"
    },
    dashboardSidebarToggle: {
      close: "Zamknij pasek boczny",
      open: "Otw\xF3rz pasek boczny"
    },
    error: {
      clear: "Powr\xF3t do strony g\u0142\xF3wnej"
    },
    fileUpload: {
      removeFile: "Usu\u0144 {filename}"
    },
    header: {
      close: "Zamknij menu",
      open: "Otw\xF3rz menu"
    },
    inputMenu: {
      create: 'Utw\xF3rz "{label}"',
      noData: "Brak danych",
      noMatch: "Brak pasuj\u0105cych danych"
    },
    inputNumber: {
      decrement: "Zmniejsz",
      increment: "Zwi\u0119ksz"
    },
    modal: {
      close: "Zamknij"
    },
    pricingTable: {
      caption: "Por\xF3wnanie plan\xF3w cenowych"
    },
    prose: {
      codeCollapse: {
        closeText: "Zwi\u0144",
        name: "kod",
        openText: "Rozwi\u0144"
      },
      collapsible: {
        closeText: "Ukryj",
        name: "w\u0142a\u015Bciwo\u015Bci",
        openText: "Poka\u017C"
      },
      pre: {
        copy: "Kopiuj kod do schowka"
      }
    },
    selectMenu: {
      create: 'Utw\xF3rz "{label}"',
      noData: "Brak danych",
      noMatch: "Brak pasuj\u0105cych danych",
      search: "Szukaj..."
    },
    slideover: {
      close: "Zamknij"
    },
    table: {
      noData: "Brak danych"
    },
    toast: {
      close: "Zamknij"
    }
  }
});
